import React, { PureComponent } from 'react'

import theme from '../../theme'

// material ui
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'
import Typography from '@mui/material/Typography';
import SettingIcon from '@mui/icons-material/Settings'
import IconButton from '@mui/material/IconButton'
import Input from '@mui/material/Input'
import { Box } from '@mui/material'

// application assets
import AIIcon from '../../assets/aiSVG'
import DIIcon from '../../assets/diSVG'
import FanSystemsIcon from '../../assets/fanSystemsSVG'
import AreasIcon from '../../assets/areasSVG'
import DOIcon from '../../assets/exitDoSVG'
import FactorySettingIcon from '../../assets/factorySettingsSVG'

// application components
import Card from '../../components/Card/Card'
import CardTextElement from '../../components/Card/CardText'
import Sidebar, { SidebarItem } from '../../components/Sidebar'
import SidebarCheckbox from '../../components/Sidebar/SidebarItem/SidebarCheckbox'
import Graph from '../../components/Graph'
import CustomizedSwitch from "../../components/CustomizedSwitch/CustomizedSwitch"
import log from 'loglevel'
import {t} from 'i18next'
import {Trans} from 'react-i18next'

// application specific utils
import {
    parseShockVentNumberToString,
    parseDIfunNumberToName,
    getBitValueFromByteArray,
    parseDOfunNumberToName,
    parseAIfunNumberToName,
    getControlFirmwareVersionNumeric,
    parseVentSysNumberToName,
    parseVentSysAreaNumberToName,
    parseAItypeNumberToName,
    isActualControlFirmwareVersionNewerThanOrEqualTargetVersion,
} from '../../../utils/elsc_utils'

const styles = {
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        display: 'flex',
        height: '100%',
    },
    cardWrapper: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowX:'hidden',
        overflowY:"auto",
        height:'100%',
        marginBottom:20,
        paddingBottom:20,
        //flexWrap: 'wrap',
        //maxWidth: '80%',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
            //marginBottom:20,
            //paddingBottom:20,

        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
            //marginBottom:20,
            //paddingBottom:20,

        }
    },
    cardsTitle: {
        //position: 'absolute',
        marginTop: 20,
        marginBottom: 10,
        padding: '0 10px 10px 0',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '7px',
        },
    },
    cards: {
        //position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        paddingTop: theme.spacing.unit * 8,
        marginBottom:theme.dimensions.cardGap,
        paddingBottom:20,

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom:theme.dimensions.cardGap,
            paddingBottom:20,
        },
    },
    // view specific
    formControl: {
        height: 130,
        display: 'flex',
        justifyContent: 'space-around',
        [theme.breakpoints.down('xs')]: {
            height: 100,
        },
    },
    helper: {
        marginTop: '-15px',
        [theme.breakpoints.down('xs')]: {
            marginTop: 0,
        },
    },
    factoryResetFont: {
        fontWeight: 600,
        lineHeight: 2,
        color: theme.palette.error.dark,
        marginBottom: 20,
    },
    selectRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    select: {
        display:"flex"
    },
    icon: {
        fill: theme.palette.primary.dark,
    },
}

class Setup extends PureComponent {
    state = {
        activeCard: '',         // which card element is active
        sidebarOpen: false,     // sidebar flag
        selectedValue: '',      // value from select elements
        sidebarChanged: false,  // data changing set

        // TODO: 'consider refactoring into one flag'
        factoryReset: false,    // if factory resets will set
        aiCurve: false, // flag if curve for ai is open


        // data for ventilation systems and areas
        systems: {
            1: {
                type: this.props.setupData.id_60 ? parseVentSysNumberToName(this.props.setupData.id_60) : "Keins",
                installed: this.props.setupData.id_66 ? parseVentSysAreaNumberToName(this.props.setupData.id_66 ) : "Bereich 1"
            },// ventilation: 'Zuluft' },
            2: {
                type: this.props.setupData.id_61 ? parseVentSysNumberToName(this.props.setupData.id_61) : "Keins",
                installed: this.props.setupData.id_67 ? parseVentSysAreaNumberToName(this.props.setupData.id_67 ) : "Bereich 2"
            },// ventilation: 'Zuluft' },
            3: {
                type: this.props.setupData.id_62 ? parseVentSysNumberToName(this.props.setupData.id_62) : "Keins",
                installed: this.props.setupData.id_68 ? parseVentSysAreaNumberToName(this.props.setupData.id_68 ) : "Bereich 3"
            },// ventilation: 'Zuluft' },
            4: {
                type: this.props.setupData.id_63 ? parseVentSysNumberToName(this.props.setupData.id_63) : "Keins",
                installed: this.props.setupData.id_69 ? parseVentSysAreaNumberToName(this.props.setupData.id_69 ) : "Bereich 4"
            },// ventilation: 'Zuluft' },
            5: {
                type: this.props.setupData.id_64 ? parseVentSysNumberToName(this.props.setupData.id_64) : "Keins",
                installed: this.props.setupData.id_70 ? parseVentSysAreaNumberToName(this.props.setupData.id_70 ) : "Bereich 5"
            },// ventilation: 'Zuluft' },
            6: {
                type: this.props.setupData.id_65 ? parseVentSysNumberToName(this.props.setupData.id_65) : "Keins",
                installed: this.props.setupData.id_71 ? parseVentSysAreaNumberToName(this.props.setupData.id_71 ) : "Bereich 6"
            },// ventilation: 'Zuluft' },
        },
        systemsChanged : false,

        shockVentilation: {
            1: this.props.setupData.id_72 ? parseShockVentNumberToString(this.props.setupData.id_72) :'Beides',
            2: this.props.setupData.id_73 ? parseShockVentNumberToString(this.props.setupData.id_73) :'Beides',
            3: this.props.setupData.id_74 ? parseShockVentNumberToString(this.props.setupData.id_74) :'Beides',
            4: this.props.setupData.id_75 ? parseShockVentNumberToString(this.props.setupData.id_75) :'Beides',
            5: this.props.setupData.id_76 ? parseShockVentNumberToString(this.props.setupData.id_76) :'Beides',
            6: this.props.setupData.id_77 ? parseShockVentNumberToString(this.props.setupData.id_77) :'Beides',
        },
        shockVentilationChanged : false,

        // data for di, ai and do
        io: {
            di: {
                function: this.props.setupData.id_84 ? parseDIfunNumberToName(parseInt(this.props.setupData.id_84, 10)) : "Keine",
                areas: {
                    1: this.props.setupData.id_85 ? getBitValueFromByteArray(0, "string", this.props.setupData.id_85) : false,
                    2: this.props.setupData.id_85 ? getBitValueFromByteArray(1, "string", this.props.setupData.id_85) : false,
                    3: this.props.setupData.id_85 ? getBitValueFromByteArray(2, "string", this.props.setupData.id_85) : false,
                    4: this.props.setupData.id_85 ? getBitValueFromByteArray(3, "string", this.props.setupData.id_85) : false,
                    5: this.props.setupData.id_85 ? getBitValueFromByteArray(4, "string", this.props.setupData.id_85) : false,
                    6: this.props.setupData.id_85 ? getBitValueFromByteArray(5, "string", this.props.setupData.id_85) : false,
                }
            },
            ai: {
                function: this.props.setupData.id_88 ? parseAIfunNumberToName(parseInt(this.props.setupData.id_88, 10)) : "Keine",
                functionType: this.props.setupData.id_90 ? parseAItypeNumberToName(parseInt(this.props.setupData.id_90,10)):"0-10V",
                areas: {
                    1: this.props.setupData.id_89 ? getBitValueFromByteArray(0, "string", this.props.setupData.id_89) : false,
                    2: this.props.setupData.id_89 ? getBitValueFromByteArray(1, "string", this.props.setupData.id_89) : false,
                    3: this.props.setupData.id_89 ? getBitValueFromByteArray(2, "string", this.props.setupData.id_89) : false,
                    4: this.props.setupData.id_89 ? getBitValueFromByteArray(3, "string", this.props.setupData.id_89) : false,
                    5: this.props.setupData.id_89 ? getBitValueFromByteArray(4, "string", this.props.setupData.id_89) : false,
                    6: this.props.setupData.id_89 ? getBitValueFromByteArray(5, "string", this.props.setupData.id_89) : false,
                },
                curveParams: {
                    x: {
                        1: this.props.setupData.id_91 ? parseInt(this.props.setupData.id_91, 10) : 0,
                        2: this.props.setupData.id_92 ? parseInt(this.props.setupData.id_92, 10) : 100,
                    },
                    y_fanlevel: {
                        1: this.props.setupData.id_93 ? parseInt(this.props.setupData.id_93, 10) : 0,
                        2: this.props.setupData.id_94 ? parseInt(this.props.setupData.id_94, 10) : 6,
                    },
                    y_humi: {
                        1: this.props.setupData.id_95? parseInt(this.props.setupData.id_95, 10) : 0,
                        2: this.props.setupData.id_96? parseInt(this.props.setupData.id_96, 10) : 100,
                    },
                    y_coco: {
                        1: this.props.setupData.id_97? parseInt(this.props.setupData.id_97, 10) : 250,
                        2: this.props.setupData.id_98? parseInt(this.props.setupData.id_98, 10) : 2000,
                    },
                    y_temp: {
                        1: this.props.setupData.id_99? parseInt(this.props.setupData.id_99, 10) : -50,
                        2: this.props.setupData.id_100? parseInt(this.props.setupData.id_100, 10) : 50,
                    },
                }
             },
            do: {
                function: this.props.setupData.id_86 ? parseDOfunNumberToName(parseInt(this.props.setupData.id_86, 10)) : "Keine",
                areas: {
                    1: this.props.setupData.id_87 ? getBitValueFromByteArray(0, "string", this.props.setupData.id_87) : false,
                    2: this.props.setupData.id_87 ? getBitValueFromByteArray(1, "string", this.props.setupData.id_87) : false,
                    3: this.props.setupData.id_87 ? getBitValueFromByteArray(2, "string", this.props.setupData.id_87) : false,
                    4: this.props.setupData.id_87 ? getBitValueFromByteArray(3, "string", this.props.setupData.id_87) : false,
                    5: this.props.setupData.id_87 ? getBitValueFromByteArray(4, "string", this.props.setupData.id_87) : false,
                    6: this.props.setupData.id_87 ? getBitValueFromByteArray(5, "string", this.props.setupData.id_87) : false,
                }
            },
        },
        ioChanged: {
            di: false,
            do: false,
            ai: false,
        },
        controlFirmwareVersion: this.props.setupData.id_3 ? getControlFirmwareVersionNumeric(this.props.setupData.id_3) : 0,
        ranges: {
            x: {
                1: [0,50],
                2: [50,100]
            },
            y_fanlevel: {
                1: [0,3],
                2: [3,6]
            },
            y_humi: {
                1: [0,50],
                2: [50,100]
            },
            y_coco: {
                1: [0,1500],
                2: [1500,5000]
            },
            y_temp: {
                1: [-50,0],
                2: [0,50]
            },
        },
        stepSizes: {
            x: 1,
            y_fanlevel: 1,
            y_humi: 1,
            y_coco: 10,
            y_temp: 1,
        },
        rangeErrors: [],
        stepErrors: [],

        tmp: {},
    }

    componentWillMount() {
        // this.props.onMyLoad()
    }

    componentWillReceiveProps(nextProps) {
        let change = false

        if (nextProps.setupData.id_3 !== this.props.setupData.id_3) { change = true }
        if (nextProps.setupData.id_60 !== this.props.setupData.id_60) { change = true }
        if (nextProps.setupData.id_61 !== this.props.setupData.id_61) { change = true }
        if (nextProps.setupData.id_62 !== this.props.setupData.id_62) { change = true }
        if (nextProps.setupData.id_63 !== this.props.setupData.id_63) { change = true }
        if (nextProps.setupData.id_64 !== this.props.setupData.id_64) { change = true }
        if (nextProps.setupData.id_65 !== this.props.setupData.id_65) { change = true }
        if (nextProps.setupData.id_66 !== this.props.setupData.id_66) { change = true }
        if (nextProps.setupData.id_67 !== this.props.setupData.id_67) { change = true }
        if (nextProps.setupData.id_68 !== this.props.setupData.id_68) { change = true }
        if (nextProps.setupData.id_69 !== this.props.setupData.id_69) { change = true }
        if (nextProps.setupData.id_70 !== this.props.setupData.id_70) { change = true }
        if (nextProps.setupData.id_71 !== this.props.setupData.id_71) { change = true }
        if (nextProps.setupData.id_72 !== this.props.setupData.id_72) { change = true }
        if (nextProps.setupData.id_73 !== this.props.setupData.id_73) { change = true }
        if (nextProps.setupData.id_74 !== this.props.setupData.id_74) { change = true }
        if (nextProps.setupData.id_75 !== this.props.setupData.id_75) { change = true }
        if (nextProps.setupData.id_76 !== this.props.setupData.id_76) { change = true }
        if (nextProps.setupData.id_77 !== this.props.setupData.id_77) { change = true }
        if (nextProps.setupData.id_84 !== this.props.setupData.id_84) { change = true }
        if (nextProps.setupData.id_85 !== this.props.setupData.id_85) { change = true }
        if (nextProps.setupData.id_86 !== this.props.setupData.id_86) { change = true }
        if (nextProps.setupData.id_87 !== this.props.setupData.id_87) { change = true }
        if (nextProps.setupData.id_88 !== this.props.setupData.id_88) { change = true }
        if (nextProps.setupData.id_89 !== this.props.setupData.id_89) { change = true }
        if (nextProps.setupData.id_90 !== this.props.setupData.id_90) { change = true }
        if (nextProps.setupData.id_91 !== this.props.setupData.id_91) { change = true }
        if (nextProps.setupData.id_92 !== this.props.setupData.id_92) { change = true }
        if (nextProps.setupData.id_93 !== this.props.setupData.id_93) { change = true }
        if (nextProps.setupData.id_94 !== this.props.setupData.id_94) { change = true }
        if (nextProps.setupData.id_95 !== this.props.setupData.id_95) { change = true }
        if (nextProps.setupData.id_96 !== this.props.setupData.id_96) { change = true }
        if (nextProps.setupData.id_97 !== this.props.setupData.id_97) { change = true }
        if (nextProps.setupData.id_98 !== this.props.setupData.id_98) { change = true }
        if (nextProps.setupData.id_99 !== this.props.setupData.id_99) { change = true }
        if (nextProps.setupData.id_100 !== this.props.setupData.id_100) { change = true }

        if (change === true) {
            this.setState(prevState => ({
                ...this.state,
                systems: {
                    1: {
                        type: nextProps.setupData.id_60 ? parseVentSysNumberToName(nextProps.setupData.id_60) : "Keins",
                        installed: nextProps.setupData.id_66 ? parseVentSysAreaNumberToName(nextProps.setupData.id_66) : "Bereich 1"
                    },// ventilation: 'Zuluft' },
                    2: {
                        type: nextProps.setupData.id_61 ? parseVentSysNumberToName(nextProps.setupData.id_61) : "Keins",
                        installed: nextProps.setupData.id_67 ? parseVentSysAreaNumberToName(nextProps.setupData.id_67) : "Bereich 2"
                    },// ventilation: 'Zuluft' },
                    3: {
                        type: nextProps.setupData.id_62 ? parseVentSysNumberToName(nextProps.setupData.id_62) : "Keins",
                        installed: nextProps.setupData.id_68 ? parseVentSysAreaNumberToName(nextProps.setupData.id_68) : "Bereich 3"
                    },// ventilation: 'Zuluft' },
                    4: {
                        type: nextProps.setupData.id_63 ? parseVentSysNumberToName(nextProps.setupData.id_63) : "Keins",
                        installed: nextProps.setupData.id_69 ? parseVentSysAreaNumberToName(nextProps.setupData.id_69) : "Bereich 4"
                    },// ventilation: 'Zuluft' },
                    5: {
                        type: nextProps.setupData.id_64 ? parseVentSysNumberToName(nextProps.setupData.id_64) : "Keins",
                        installed: nextProps.setupData.id_70 ? parseVentSysAreaNumberToName(nextProps.setupData.id_70) : "Bereich 5"
                    },// ventilation: 'Zuluft' },
                    6: {
                        type: nextProps.setupData.id_65 ? parseVentSysNumberToName(nextProps.setupData.id_65) : "Keins",
                        installed: nextProps.setupData.id_71 ? parseVentSysAreaNumberToName(nextProps.setupData.id_71) : "Bereich 6"
                    },// ventilation: 'Zuluft' },
                },


                shockVentilation: {
                    1: nextProps.setupData.id_72 ? parseShockVentNumberToString(nextProps.setupData.id_72) : 'Beides',
                    2: nextProps.setupData.id_73 ? parseShockVentNumberToString(nextProps.setupData.id_73) : 'Beides',
                    3: nextProps.setupData.id_74 ? parseShockVentNumberToString(nextProps.setupData.id_74) : 'Beides',
                    4: nextProps.setupData.id_75 ? parseShockVentNumberToString(nextProps.setupData.id_75) : 'Beides',
                    5: nextProps.setupData.id_76 ? parseShockVentNumberToString(nextProps.setupData.id_76) : 'Beides',
                    6: nextProps.setupData.id_77 ? parseShockVentNumberToString(nextProps.setupData.id_77) : 'Beides',
                },


                // data for di, ai and do
                io: {
                    di: {
                        function: nextProps.setupData.id_84 ? parseDIfunNumberToName(parseInt(nextProps.setupData.id_84, 10)) : "Keine",
                        areas: {
                            1: nextProps.setupData.id_85 ? getBitValueFromByteArray(0, "string", nextProps.setupData.id_85) : false,
                            2: nextProps.setupData.id_85 ? getBitValueFromByteArray(1, "string", nextProps.setupData.id_85) : false,
                            3: nextProps.setupData.id_85 ? getBitValueFromByteArray(2, "string", nextProps.setupData.id_85) : false,
                            4: nextProps.setupData.id_85 ? getBitValueFromByteArray(3, "string", nextProps.setupData.id_85) : false,
                            5: nextProps.setupData.id_85 ? getBitValueFromByteArray(4, "string", nextProps.setupData.id_85) : false,
                            6: nextProps.setupData.id_85 ? getBitValueFromByteArray(5, "string", nextProps.setupData.id_85) : false,
                        }
                    },
                    ai: {
                        function: nextProps.setupData.id_88 ? parseAIfunNumberToName(parseInt(nextProps.setupData.id_88, 10)) : "Keine",
                        functionType: nextProps.setupData.id_90 ? parseAItypeNumberToName(parseInt(nextProps.setupData.id_90, 10)) : "0-10V",
                        areas: {
                            1: nextProps.setupData.id_89 ? getBitValueFromByteArray(0, "string", nextProps.setupData.id_89) : false,
                            2: nextProps.setupData.id_89 ? getBitValueFromByteArray(1, "string", nextProps.setupData.id_89) : false,
                            3: nextProps.setupData.id_89 ? getBitValueFromByteArray(2, "string", nextProps.setupData.id_89) : false,
                            4: nextProps.setupData.id_89 ? getBitValueFromByteArray(3, "string", nextProps.setupData.id_89) : false,
                            5: nextProps.setupData.id_89 ? getBitValueFromByteArray(4, "string", nextProps.setupData.id_89) : false,
                            6: nextProps.setupData.id_89 ? getBitValueFromByteArray(5, "string", nextProps.setupData.id_89) : false,
                        },
                        curveParams: {
                            x: {
                                1: nextProps.setupData.id_91 ? parseInt(nextProps.setupData.id_91, 10) : 0,
                                2: nextProps.setupData.id_92 ? parseInt(nextProps.setupData.id_92, 10) : 100,
                            },
                            y_fanlevel: {
                                1: nextProps.setupData.id_93 ? parseInt(nextProps.setupData.id_93, 10) : 0,
                                2: nextProps.setupData.id_94 ? parseInt(nextProps.setupData.id_94, 10) : 6,
                            },
                            y_humi: {
                                1: nextProps.setupData.id_95 ? parseInt(nextProps.setupData.id_95, 10) : 0,
                                2: nextProps.setupData.id_96 ? parseInt(nextProps.setupData.id_96, 10) : 100,
                            },
                            y_coco: {
                                1: nextProps.setupData.id_97 ? parseInt(nextProps.setupData.id_97, 10) : 250,
                                2: nextProps.setupData.id_98 ? parseInt(nextProps.setupData.id_98, 10) : 2000,
                            },
                            y_temp: {
                                1: nextProps.setupData.id_99 ? parseInt(nextProps.setupData.id_99, 10) : -50,
                                2: nextProps.setupData.id_100 ? parseInt(nextProps.setupData.id_100, 10) : 50,
                            },
                        }
                    },
                    do: {
                        function: nextProps.setupData.id_86 ? parseDOfunNumberToName(parseInt(nextProps.setupData.id_86, 10)) : "Keine",
                        areas: {
                            1: nextProps.setupData.id_87 ? getBitValueFromByteArray(0, "string", nextProps.setupData.id_87) : false,
                            2: nextProps.setupData.id_87 ? getBitValueFromByteArray(1, "string", nextProps.setupData.id_87) : false,
                            3: nextProps.setupData.id_87 ? getBitValueFromByteArray(2, "string", nextProps.setupData.id_87) : false,
                            4: nextProps.setupData.id_87 ? getBitValueFromByteArray(3, "string", nextProps.setupData.id_87) : false,
                            5: nextProps.setupData.id_87 ? getBitValueFromByteArray(4, "string", nextProps.setupData.id_87) : false,
                            6: nextProps.setupData.id_87 ? getBitValueFromByteArray(5, "string", nextProps.setupData.id_87) : false,
                        }
                    },
                },
                controlFirmwareVersion: nextProps.setupData.id_3 ? getControlFirmwareVersionNumeric(nextProps.setupData.id_3) : 0,
                tmp: {
                    ...prevState.tmp
                }
            })
            )
        }

    }

    componentDidMount() {
        log.debug(this.state)
        this.setState(prevState => ({
            tmp: {
                ...prevState.tmp,
                systems: prevState.systems,
                io: prevState.io,
                shockVentilation: prevState.shockVentilation
            },
        }))

        log.debug(this.state)
    }

    /**
     * set active card
     * @param activeCard
     */
    changeCard = activeCard => {
        this.setState({
            sidebarOpen: true,
            sidebarChanged: false,
            factoryReset: false,
            aiCurve: false,
            shockVentilationChanged: false,
            ioChanged: {
                di: false,
                do: false,
                ai: false
            },
            systemsChanged : false,
            activeCard,
            rangeErrors: [],
            stepErrors: [],
        })
        this.props.onMyLoad()
    }

    /**
     * set selection for type and installed of ventilation system
     * @param selectedValue
     * @param sysKey
     */
    handleTypeSelectChange = (selectedValue, sysKey, property) => {
        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: { ...prevState.tmp,
                systems: {
                    ...prevState.tmp.systems,
                    [sysKey]: { ...prevState.tmp.systems[sysKey], [property]: selectedValue },
                },
            },
            systemsChanged: true,
            // systems: { ...this.state.systems, [sysKey]: { ...this.state.systems[sysKey], [property]: selectedValue } },
        }))
    }

    /**
     * set selection for ventilation types
     * @param selectedValue
     * @param sysKey
     */
    handleAreaSelectChange = (selectedValue, sysKey) => {
        log.debug(selectedValue)
        log.debug(sysKey)
        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: { ...prevState.tmp,
                shockVentilation: {
                    ...prevState.tmp.shockVentilation,
                    [sysKey]:   selectedValue ,
                },
            },
            shockVentilationChanged: true,
        }))
        log.debug(this.state)
    }

    /**
     * set function for io
     * @param selectedValue
     */
    handleFunctionChange = selectedValue => {
        let stateObject = []

        if ('Eingang DI' === this.state.activeCard) {
            stateObject = 'di'
        } else if ('Eingang AI' === this.state.activeCard) {
            stateObject = 'ai'
        } else {
            stateObject = 'do'
        }

        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    [stateObject]: { ...prevState.tmp.io[stateObject], function: selectedValue },
                },
            },
        }))
    }

        /**
     * set function for di
     * @param selectedValue
     */
    handleDIfunctionChange = selectedValue => {


        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    di: { ...prevState.tmp.io.di, function: selectedValue },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                di: true,
            }
        }))
    }

            /**
     * set function for di
     * @param selectedValue
     */
    handleDOfunctionChange = selectedValue => {


        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    do: { ...prevState.tmp.io.do, function: selectedValue },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                do: true,
            }
        }))
    }

               /**
     * set function for ai
     * @param selectedValue
     */
    handleAIfunctionChange = selectedValue => {


        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    ai: { ...prevState.tmp.io.ai, function: selectedValue },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                ai: true,
            }
        }))
    }

    /**
     * set selected function for ai
     * @param selectedValue
     */
    handleFunctionTypeChange = selectedValue => {
        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    ai: { ...prevState.tmp.io.ai, functionType: selectedValue },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                ai: true,
            }
        }))
    }

    /**
     * set checkbox state for all three cases
     * @param checkedElement
     */
    handleSwitchChange = checkedElement => {
        let systems = []
        let stateObject = []

        if ('Eingang DI' === this.state.activeCard) {
            stateObject = 'di'
        } else if ('Eingang AI' === this.state.activeCard) {
            stateObject = 'ai'
        } else {
            stateObject = 'do'
        }

        if (this.state.tmp.io[stateObject].systems.includes(checkedElement)) {
            const index = this.state.tmp.io[stateObject].systems.indexOf(checkedElement)
            systems = [...this.state.tmp.io[stateObject].systems.slice(0, index), ...this.state.tmp.io[stateObject].systems.slice(index + 1)]
        } else {
            systems = [...this.state.tmp.io[stateObject].systems, checkedElement]
        }

        systems = systems.sort()

        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    [stateObject]: {
                        ...prevState.tmp.io[stateObject],
                        systems,
                    },
                },
            },
        }))
    }

    handleDISwitchChange = checkedElement => {

        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    di: {
                        ...prevState.tmp.io.di,
                        areas : {
                            ...prevState.tmp.io.di.areas,
                            [checkedElement] : !this.state.tmp.io.di.areas[checkedElement]
                        }
                        // systems,
                    },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                di: true,
            }
        }))
        log.debug(this.state.io.di)

        log.debug(this.state.tmp.io.di)
    }

    handleDOSwitchChange = checkedElement => {

        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    do: {
                        ...prevState.tmp.io.do,
                        areas : {
                            ...prevState.tmp.io.do.areas,
                            [checkedElement] : !this.state.tmp.io.do.areas[checkedElement]
                        }
                        // systems,
                    },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                do: true,
            }
        }))
        log.debug(this.state.io.do)

        log.debug(this.state.tmp.io.do)
    }

    handleAISwitchChange = checkedElement => {

        this.setState(prevState => ({
            sidebarChanged: true,
            tmp: {
                ...prevState.tmp, io: {
                    ...prevState.tmp.io,
                    ai: {
                        ...prevState.tmp.io.ai,
                        areas : {
                            ...prevState.tmp.io.ai.areas,
                            [checkedElement] : !this.state.tmp.io.ai.areas[checkedElement]
                        }
                        // systems,
                    },
                },
            },
            ioChanged: {
                ...prevState.tmp.ioChanged,
                ai: true,
            }
        }))
        log.debug(this.state.io.ai)

        log.debug(this.state.tmp.io.ai)
    }

    /**
     * closing sidebar
     */
    handleSidebarClose = () => {
        this.setState((prevState => ({
            factoryReset: false,
            activeCard: '',
            sidebarOpen: !prevState.sidebarOpen,
            sidebarChanged: false,
            systemsChanged: false,
            aiCurve: false,
            tmp: { ...prevState.tmp, systems: prevState.systems, io: prevState.io, shockVentilation: prevState.shockVentilation },
            shockVentilationChanged: false,
            ioChanged: {
                di: false,
                do: false,
                ai: false
            }
        })))
        this.props.onMyLoad()

    }

    /**
     * reset to factory settings (only flag changed)
     */
    resetToFactorySetting = () => {
        this.setState((prevState => ({
            factoryReset: !prevState.factoryReset,
        })))
    }

    /**
     * if user changes sidebar content and save
     */
    handleSidebarChange = () => {
        log.debug('handleSidebarChange fired')
        log.debug(this.state)
        if (this.state.factoryReset) {
            // do a factory reset
            this.setState({ factoryReset: false })
            this.props.onFactoryReset()
        }

        if(this.state.systemsChanged){
            this.setState(prevState => ( {
                sidebarChanged: false,
                systems: { ...prevState.tmp.systems },
                io: { ...prevState.tmp.io },
                shockVentilation: {...prevState.tmp.shockVentilation},
                shockVentilationChanged : false,
                systemsChanged : false
            }))
            log.debug(this.state)
            this.props.onSystemsChange(this.state.tmp.systems)
        }

        if(this.state.shockVentilationChanged === true){
            log.debug("tralala")
            this.setState(prevState => ({
                sidebarChanged: false,
                systems: { ...prevState.tmp.systems },
                io: { ...prevState.tmp.io },
                shockVentilation: {...prevState.tmp.shockVentilation},
                shockVentilationChanged : false,
            }))
            log.debug(this.state)
            this.props.onShockVentilationChange(this.state.tmp.shockVentilation)
        }

        if(this.state.ioChanged.di === true){
            log.debug('trololol')

                this.setState(prevState => ({
                    sidebarChanged: false,
                    systems: { ...prevState.tmp.systems },
                    io: { ...prevState.tmp.io },
                    shockVentilation: {...prevState.tmp.shockVentilation},
                    shockVentilationChanged : false,
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        di: false,
                    }
                }))
                this.props.onDIsetupChange(this.state.tmp.io.di.areas, this.state.tmp.io.di.function)

        }

        if(this.state.ioChanged.do === true){
            log.debug('trololol')

                this.setState(prevState => ({
                    sidebarChanged: false,
                    systems: { ...prevState.tmp.systems },
                    io: { ...prevState.tmp.io },
                    shockVentilation: {...prevState.tmp.shockVentilation},
                    shockVentilationChanged : false,
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        do: false,
                    }
                }))
                this.props.onDOsetupChange(this.state.tmp.io.do.areas, this.state.tmp.io.do.function)

        }

        if((this.state.ioChanged.ai === true) ){
            log.debug('trololol')

                var curveFlag = false

                if(this.state.aiCurve){
                    curveFlag = true
                }

                this.setState(prevState => ({
                    sidebarChanged: false,
                    systems: { ...prevState.tmp.systems },
                    io: { ...prevState.tmp.io },
                    shockVentilation: {...prevState.tmp.shockVentilation},
                    shockVentilationChanged : false,
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        ai: false,
                    },
                    aiCurve: false,
                }))
                this.props.onAIsetupChange(this.state.tmp.io.ai.areas, this.state.tmp.io.ai.function, this.state.tmp.io.ai.functionType)
                if(curveFlag){
                    this.props.onAIcurveChange(this.state.tmp.io.ai.curveParams)
                }

        }


    }

    /**
     * factory reset
     * @returns {*}
     */
    getFactoryResetContent = () => {
        const { classes } = this.props

        return (
            <SidebarItem>
                <Typography style={styles.factoryResetFont} color='error'><Trans i18nKey="Global.heading_caution_caps_lock"></Trans>:</Typography>
                <Typography style={styles.factoryResetFont}>
                    <Trans i18nKey="Setup.text_factoryreset_01"></Trans>
                </Typography>
                <Typography style={styles.factoryResetFont}>
                <Trans i18nKey="Setup.text_factoryreset_02"></Trans>
                </Typography>
            </SidebarItem>
        )
    }

    /**
     * select content for areas
     * @returns {any[]}
     */
    getAreasContent = () => {
        //const {styles} = this.props
        log.debug(this.state.tmp.shockVentilation)
        const areasContent = Object.keys(this.state.tmp.shockVentilation)
            .map(sysKey => (

                <SidebarItem title={t('Setup.name_area') +` ${ sysKey }`} key={`Bereich ${ sysKey }`} divider>
                    <FormControl fullWidth>
                        <Select
                            style={{display:'flex'}}
                                            inputProps={{
                                                style: {
                                                    icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                        underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                            value={this.state.tmp.shockVentilation[sysKey]}
                            displayEmpty
                            onChange={event => this.handleAreaSelectChange(event.target.value, sysKey)}
                        >
                            <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                            <MenuItem value="Beides"><Trans i18nKey="Setup.menuitem_boostmode_both"></Trans></MenuItem>
                            <MenuItem value="Abluft"><Trans i18nKey="Setup.menuitem_boostmode_exhaust"></Trans></MenuItem>
                            <MenuItem value="Zuluft"><Trans i18nKey="Setup.menuitem_boostmode_supply"></Trans></MenuItem>
                        </Select>
                        <FormHelperText><Trans i18nKey="Setup.helpertext_boostmode"></Trans></FormHelperText>
                    </FormControl>
                </SidebarItem>
            ))

        return areasContent
    }

    /**
     * for areas and ventilation systems
     * @returns {Array}
     */
    getVentilationSystemsContent = () => {
        const { styles } = this.props
        log.debug(this.state)
        log.debug(this.props)
        log.debug(isActualControlFirmwareVersionNewerThanOrEqualTargetVersion(this.state.controlFirmwareVersion, getControlFirmwareVersionNumeric("SWZ0021E21F")))
        log.debug(isActualControlFirmwareVersionNewerThanOrEqualTargetVersion(this.state.controlFirmwareVersion, getControlFirmwareVersionNumeric("SWZ0021E21G")))
        log.debug(isActualControlFirmwareVersionNewerThanOrEqualTargetVersion(this.state.controlFirmwareVersion, getControlFirmwareVersionNumeric("SWZ0021E21H")))
        const decisionForVersionGorNewer = isActualControlFirmwareVersionNewerThanOrEqualTargetVersion(this.state.controlFirmwareVersion, getControlFirmwareVersionNumeric("SWZ0021E21G"))
        const ventilationSystems = Object.keys(this.state.tmp.systems)
            .map(sysKey => (
                <SidebarItem title={t('Setup.name_system') + ` ${sysKey}`} key={`System ${sysKey}`} divider>
                    <FormControl fullWidth /* style={styles.formControl} */>
                        <Select
                            style={{display:'flex'}}
                                            inputProps={{
                                                style: {
                                                    //icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                       // underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                            value={this.state.tmp.systems[sysKey].type}
                            onChange={event => this.handleTypeSelectChange(event.target.value, sysKey, 'type')}
                        >
                            <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                            <MenuItem value="Keins"><Trans i18nKey="Setup.menuitem_system_none"></Trans></MenuItem>
                            <MenuItem value="SEVi160">SEVi160</MenuItem>
                            <MenuItem value="SEVi200">SEVi200</MenuItem>
                            <MenuItem value="SEVi160D Mini Abluft">SEVi160D Mini <Trans i18nKey="Setup.menuitem_boostmode_exhaust"></Trans></MenuItem>
                            <MenuItem value="SEVi160D Mini">SEVi160D Mini</MenuItem>

                            {decisionForVersionGorNewer && <MenuItem value="SEVi160 S">SEVi160 S</MenuItem>}
                            {decisionForVersionGorNewer && <MenuItem value="SEVi160 Eco">SEVi160 Eco</MenuItem>}
                            {decisionForVersionGorNewer && <MenuItem value="SEVi160 PRO-S">SEVi160 PRO-S</MenuItem>}
                            {decisionForVersionGorNewer && <MenuItem value="SEVi160 PRO-ECO">SEVi160 PRO-ECO</MenuItem>}
                            {decisionForVersionGorNewer && <MenuItem value="SEVi160D Mini PRO Abluft">SEVi160D Mini PRO <Trans i18nKey="Setup.menuitem_boostmode_exhaust"></Trans></MenuItem>}
                            {decisionForVersionGorNewer && <MenuItem value="SEVi160D Mini PRO">SEVi160D Mini PRO</MenuItem>}
                            {decisionForVersionGorNewer && <MenuItem value="Konfigurierbares Gerät"><Trans i18nKey="Setup.menuitem_system_configurable_device"></Trans></MenuItem>}

                        </Select>
                        <FormHelperText /* style={{...styles.helper}} */><Trans i18nKey="Setup.helpertext_systems"></Trans></FormHelperText>
                        <Select
                            style={{display:'flex'}}
                                            inputProps={{
                                                styles: {
                                                    //icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                        //underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                            value={this.state.tmp.systems[sysKey].installed}
                            displayEmpty
                            onChange={event => this.handleTypeSelectChange(event.target.value, sysKey, 'installed')}
                            disabled={'Keins' === this.state.tmp.systems[sysKey].type}
                        >
                            <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                            <MenuItem value="Bereich 1"><Trans i18nKey="Setup.menuitem_area1"></Trans></MenuItem>
                            <MenuItem value="Bereich 2"><Trans i18nKey="Setup.menuitem_area2"></Trans></MenuItem>
                            <MenuItem value="Bereich 3"><Trans i18nKey="Setup.menuitem_area3"></Trans></MenuItem>
                            <MenuItem value="Bereich 4"><Trans i18nKey="Setup.menuitem_area4"></Trans></MenuItem>
                            <MenuItem value="Bereich 5"><Trans i18nKey="Setup.menuitem_area5"></Trans></MenuItem>
                            <MenuItem value="Bereich 6"><Trans i18nKey="Setup.menuitem_area6"></Trans></MenuItem>
                        </Select>
                        <FormHelperText /* style={styles.helper} */><Trans i18nKey="Setup.helpertext_areas_installed"></Trans></FormHelperText>
                    </FormControl>
                </SidebarItem>
            ))

        return ventilationSystems
    }

    /**
     * set flag for curve mode
     */
    handleAiCurveCurve = () => {
        this.setState(prevState => ({
            aiCurve: !prevState.aiCurve,
        }))
    }




    getAISidebarContent = () => {
        const sidebarContent = []

        const { classes } = this.props
        log.debug(this.state.tmp.io.ai.functionType)
       log.debug(this.state.tmp.io.ai.areas[1])
        sidebarContent.push(<SidebarItem title={t('Setup.sidebar_title_ai')}>
            <FormControl fullWidth>

                  <Select
                      style={{display:'flex'}}
                                            inputProps={{
                                                styles: {
                                                    icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                        underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                    value={this.state.tmp.io.ai.functionType}
                    displayEmpty
                    onChange={event => this.handleFunctionTypeChange(event.target.value)}

                >
                    <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                    <MenuItem value="0-10V"><Trans i18nKey="Setup.menuitem_ai_0_10V"></Trans></MenuItem>
                    <MenuItem value="4-20mA"><Trans i18nKey="Setup.menuitem_ai_4_20mA"></Trans></MenuItem>

                </Select>
                    <FormHelperText><Trans i18nKey="Setup.helpertext_ai_kind"></Trans></FormHelperText>

                <Select
                    style={{display:'flex'}}
                                            inputProps={{
                                                styles: {
                                                    icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                        underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                    value={this.state.tmp.io.ai.function}
                    displayEmpty
                    onChange={event => this.handleAIfunctionChange(event.target.value)}
                >
                    <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                    <MenuItem value="Keine"><Trans i18nKey="Setup.menuitem_ai_none"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe"><Trans i18nKey="Setup.menuitem_ai_fanlevel"></Trans></MenuItem>
                    <MenuItem value="Feuchte"><Trans i18nKey="Setup.menuitem_ai_humidity"></Trans></MenuItem>
                    <MenuItem value="CO2"><Trans i18nKey="Setup.menuitem_ai_co2"></Trans></MenuItem>
                    <MenuItem value="Innentemperatur"><Trans i18nKey="Setup.menuitem_ai_ti"></Trans></MenuItem>
                    <MenuItem value="Aussentemperatur"><Trans i18nKey="Setup.menuitem_ai_ta"></Trans></MenuItem>
                </Select>
                <FormHelperText><Trans i18nKey="Setup.helpertext_ai_function"></Trans></FormHelperText>
            </FormControl>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20 }}>
                    <Typography variant={'body1'}><Trans i18nKey="Setup.formtitle_ai_set_characteristic"></Trans></Typography>
                    <IconButton
                     onClick={() => this.handleAiCurveCurve()}
                     disabled = {this.state.tmp.io.ai.function === "Keine"}>
                        <SettingIcon  style={{color: theme.palette.primary.dark}} color={this.state.tmp.io.ai.function === "Keine"? "disabled": "primary"}/>
                    </IconButton>
                </div>
        </SidebarItem>)


        sidebarContent.push(<SidebarItem title={t('Setup.sidebartitle_ai_choose_areas')} divider>
            {Object.keys(this.state.io.ai.areas).map(sysKey => <SidebarCheckbox
                key={`Bereich ${sysKey}`}
                label={t('Setup.name_area') + ` ${sysKey}`}
                change={() => this.handleAISwitchChange(sysKey)}
                checked={this.state.tmp.io.ai.areas[sysKey]}
            />)
            }
        </SidebarItem>)

        return sidebarContent
    }




    getDISidebarContent = () => {
        const sidebarContent = []

        const { classes } = this.props
       log.debug(this.state.tmp.io.di.areas[1])
        sidebarContent.push(<SidebarItem title={t('Setup.sidebar_title_di')}>
            <FormControl fullWidth>
                <Select
                    style={{display:'flex'}}
                                            inputProps={{
                                                styles: {
                                                    icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                        underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                    value={this.state.tmp.io.di.function}
                    displayEmpty
                    onChange={event => this.handleDIfunctionChange(event.target.value)}
                >
                    <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                    <MenuItem value="Keine"><Trans i18nKey="Setup.menuitem_di_none"></Trans></MenuItem>
                    <MenuItem value="Setze Lüfterstufe 0"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>0</MenuItem>
                    <MenuItem value="Setze Lüfterstufe 1"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>1</MenuItem>
                    <MenuItem value="Setze Lüfterstufe 2"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>2</MenuItem>
                    <MenuItem value="Setze Lüfterstufe 3"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>3</MenuItem>
                    <MenuItem value="Setze Lüfterstufe 4"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>4</MenuItem>
                    <MenuItem value="Setze Lüfterstufe 5"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>5</MenuItem>
                    <MenuItem value="Setze Lüfterstufe 6"><Trans i18nKey="Setup.menuitem_di_set_fanlevel"></Trans>6</MenuItem>
                    <MenuItem value="Setze Stoßlüftung"><Trans i18nKey="Setup.menuitem_di_set_boost"></Trans></MenuItem>
                    <MenuItem value="Setze Schlummer"><Trans i18nKey="Setup.menuitem_di_set_sleep"></Trans></MenuItem>
                    <MenuItem value="Setze Zeitautomatik"><Trans i18nKey="Setup.menuitem_di_set_time_automatic"></Trans></MenuItem>
                    <MenuItem value="Setze CO2"><Trans i18nKey="Setup.menuitem_di_set_co2"></Trans></MenuItem>
                    <MenuItem value="Setze Feuchte"><Trans i18nKey="Setup.menuitem_di_set_humidity"></Trans></MenuItem>
                    <MenuItem value="Setze Filter zurück"><Trans i18nKey="Setup.menuitem_di_set_filter"></Trans></MenuItem>
                    <MenuItem value="Halte Lüfterstufe 0"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>0</MenuItem>
                    <MenuItem value="Halte Lüfterstufe 1"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>1</MenuItem>
                    <MenuItem value="Halte Lüfterstufe 2"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>2</MenuItem>
                    <MenuItem value="Halte Lüfterstufe 3"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>3</MenuItem>
                    <MenuItem value="Halte Lüfterstufe 4"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>4</MenuItem>
                    <MenuItem value="Halte Lüfterstufe 5"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>5</MenuItem>
                    <MenuItem value="Halte Lüfterstufe 6"><Trans i18nKey="Setup.menuitem_di_hold_fanlevel"></Trans>6</MenuItem>
                    <MenuItem value="Halte Stoßlüftung"><Trans i18nKey="Setup.menuitem_di_hold_boost"></Trans></MenuItem>
                    <MenuItem value="Halte Zeitautomatik"><Trans i18nKey="Setup.menuitem_di_hold_time_automatic"></Trans></MenuItem>
                    <MenuItem value="Halte CO2"><Trans i18nKey="Setup.menuitem_di_hold_co2"></Trans></MenuItem>
                    <MenuItem value="Halte Feuchte"><Trans i18nKey="Setup.menuitem_di_hold_humidity"></Trans></MenuItem>
                </Select>
                <FormHelperText><Trans i18nKey="Setup.helpertext_di_function"></Trans></FormHelperText>
            </FormControl>
        </SidebarItem>)


        sidebarContent.push(<SidebarItem title={t('Setup.sidebartitle_di_choose_areas')} divider>
            {Object.keys(this.state.io.di.areas).map(sysKey => <SidebarCheckbox
                key={`Bereich ${sysKey}`}
                label={t('Setup.name_area') + ` ${sysKey}`}
                change={() => this.handleDISwitchChange(sysKey)}
                checked={this.state.tmp.io.di.areas[sysKey]}
            />)
            }
        </SidebarItem>)

        return sidebarContent
    }

    getDOSidebarContent = () => {
        const sidebarContent = []

        const { classes } = this.props
       log.debug(this.state.tmp.io.do.areas[1])
        sidebarContent.push(<SidebarItem title={t('Setup.sidebar_title_do')}>
            <FormControl fullWidth>
                <Select
                    style={{display:'flex'}}
                                            inputProps={{
                                                styles: {
                                                    icon: styles.icon
                                                }
                                            }}
                                            input={
                                                <Input
                                                    styles={{
                                                        underline: styles.textFieldUnerline,
                                                    }}
                                                />
                                            }
                    value={this.state.tmp.io.do.function}
                    displayEmpty
                    onChange={event => this.handleDOfunctionChange(event.target.value)}
                >
                    <MenuItem value="" disabled><Trans i18nKey="Setup.menuitem_default"></Trans></MenuItem>
                    <MenuItem value="Keine"><Trans i18nKey="Setup.menuitem_do_none"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 0 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>0<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 1 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>1<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 2 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>2<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 3 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>3<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 4 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>4<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 5 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>5<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Lüfterstufe 6 aktiv"><Trans i18nKey="Setup.menuitem_do_fan_active_01"></Trans>6<Trans i18nKey="Setup.menuitem_do_fan_active_02"></Trans></MenuItem>
                    <MenuItem value="Stoßlüftung aktiv"><Trans i18nKey="Setup.menuitem_do_boost"></Trans></MenuItem>
                    <MenuItem value="Schlummer aktiv"><Trans i18nKey="Setup.menuitem_do_sleep"></Trans></MenuItem>
                    <MenuItem value="Alle Bereiche Lüfterstufe 0"><Trans i18nKey="Setup.menuitem_do_all_zero"></Trans></MenuItem>
                    <MenuItem value="Zeitautomatik aktiv"><Trans i18nKey="Setup.menuitem_do_time_automatic"></Trans></MenuItem>
                    <MenuItem value="CO2 aktiv"><Trans i18nKey="Setup.menuitem_do_co2"></Trans></MenuItem>
                    <MenuItem value="Feuchte aktiv"><Trans i18nKey="Setup.menuitem_do_humidity"></Trans></MenuItem>
                    <MenuItem value="Filter abgelaufen"><Trans i18nKey="Setup.menuitem_do_filter"></Trans></MenuItem>
                    <MenuItem value="Allgemeine Meldung"><Trans i18nKey="Setup.menuitem_do_message"></Trans></MenuItem>
                    <MenuItem value="Allgemeiner Fehler"><Trans i18nKey="Setup.menuitem_do_error"></Trans></MenuItem>
                </Select>
                <FormHelperText><Trans i18nKey="Setup.helpertext_do_function"></Trans></FormHelperText>
            </FormControl>
        </SidebarItem>)


        sidebarContent.push(<SidebarItem title={t('Setup.sidebartitle_do_choose_areas')} divider>
            {Object.keys(this.state.io.do.areas).map(sysKey => <SidebarCheckbox
                key={`Bereich ${sysKey}`}
                label={t('Setup.name_area') + ` ${sysKey}`}
                change={() => this.handleDOSwitchChange(sysKey)}
                checked={this.state.tmp.io.do.areas[sysKey]}
            />)
            }
        </SidebarItem>)

        return sidebarContent
    }

    showIOcardContent = areas => {
        let myString = []

        for (let index = 1; index < 7; index++){
            if(areas[index]=== true){
                myString.push(`${index}`)
            }
        }
        if(myString.length < 1){
            return t('Global.text_none')
        }
      return  myString.join(', ')
    }

    /**
     * set change flag for sidebar
     */
    handleInputCurveChange = (x,y,context) => {

        log.debug(x)
        log.debug(y)
        log.debug(context)
        log.debug(this.state)


        // x min validation
        if((x.min < context.x_min_min) || (x.min > context.x_min_max)){
            log.debug("Im in the compare")
                            if (!this.state.rangeErrors.includes('x_min')) {
                                log.debug("Im the x min error")
                    this.setState({
                        rangeErrors: [...this.state.rangeErrors, 'x_min'],
                    })
                }
        }   else if (this.state.rangeErrors.includes('x_min')) {
            const index = this.state.rangeErrors.indexOf('x_min')
            this.setState({
                rangeErrors: (0 === index) ? [] : [...this.state.rangeErrors.slice(0, index), ...this.state.rangeErrors.slice(index, +1)],
            })
        }


        if (x.min % this.state.stepSizes.x !== 0) {
            if (!this.state.stepErrors.includes('x_min')) {
                this.setState({
                    stepErrors: [...this.state.stepErrors, 'x_min'],
                })
            }
        } else if (this.state.stepErrors.includes('x_min')) {
            const index = this.state.stepErrors.indexOf('x_min')
            this.setState({
                stepErrors: (0 === index) ? [] : [...this.state.stepErrors.slice(0, index), ...this.state.stepErrors.slice(index, +1)],
            })
        }

        // x max validation
        if((x.max < context.x_max_min) || (x.max > context.x_max_max)){
            log.debug("Im in the compare")
                            if (!this.state.rangeErrors.includes('x_max')) {
                                log.debug("Im the x_max error")
                    this.setState({
                        rangeErrors: [...this.state.rangeErrors, 'x_max'],
                    })
                }
        }   else if (this.state.rangeErrors.includes('x_max')) {
            const index = this.state.rangeErrors.indexOf('x_max')
            this.setState({
                rangeErrors: (0 === index) ? [] : [...this.state.rangeErrors.slice(0, index), ...this.state.rangeErrors.slice(index, +1)],
            })
        }


        if (x.max % this.state.stepSizes.x !== 0) {
            if (!this.state.stepErrors.includes('x_max')) {
                this.setState({
                    stepErrors: [...this.state.stepErrors, 'x_max'],
                })
            }
        } else if (this.state.stepErrors.includes('x_max')) {
            const index = this.state.stepErrors.indexOf('x_max')
            this.setState({
                stepErrors: (0 === index) ? [] : [...this.state.stepErrors.slice(0, index), ...this.state.stepErrors.slice(index, +1)],
            })
        }

        // y min validation
                if((y.min < context.y_min_min) || (y.min > context.y_min_max)){
                    log.debug("Im in the compare")
                                    if (!this.state.rangeErrors.includes('y_min')) {
                                        log.debug("Im the y_min error")
                            this.setState({
                                rangeErrors: [...this.state.rangeErrors, 'y_min'],
                            })
                        }
                }   else if (this.state.rangeErrors.includes('y_min')) {
                    const index = this.state.rangeErrors.indexOf('y_min')
                    this.setState({
                        rangeErrors: (0 === index) ? [] : [...this.state.rangeErrors.slice(0, index), ...this.state.rangeErrors.slice(index, +1)],
                    })
                }


                if (y.min % context.modification !== 0) {
                    if (!this.state.stepErrors.includes('y_min')) {
                        this.setState({
                            stepErrors: [...this.state.stepErrors, 'y_min'],
                        })
                    }
                } else if (this.state.stepErrors.includes('y_min')) {
                    const index = this.state.stepErrors.indexOf('y_min')
                    this.setState({
                        stepErrors: (0 === index) ? [] : [...this.state.stepErrors.slice(0, index), ...this.state.stepErrors.slice(index, +1)],
                    })
                }

                        // y max validation
                        if((y.max < context.y_max_min) || (y.max > context.y_max_max)){
                            log.debug("Im in the compare")
                                            if (!this.state.rangeErrors.includes('y_max')) {
                                                log.debug("Im the y_max error")
                                    this.setState({
                                        rangeErrors: [...this.state.rangeErrors, 'y_max'],
                                    })
                                }
                        }   else if (this.state.rangeErrors.includes('y_max')) {
                            const index = this.state.rangeErrors.indexOf('y_max')
                            this.setState({
                                rangeErrors: (0 === index) ? [] : [...this.state.rangeErrors.slice(0, index), ...this.state.rangeErrors.slice(index, +1)],
                            })
                        }


                        if (y.max % context.modification !== 0) {
                            if (!this.state.stepErrors.includes('y_max')) {
                                this.setState({
                                    stepErrors: [...this.state.stepErrors, 'y_max'],
                                })
                            }
                        } else if (this.state.stepErrors.includes('y_max')) {
                            const index = this.state.stepErrors.indexOf('y_max')
                            this.setState({
                                stepErrors: (0 === index) ? [] : [...this.state.stepErrors.slice(0, index), ...this.state.stepErrors.slice(index, +1)],
                            })
                        }



        switch (context.index) {
            default:
            case 0:
                break;
            case 1:
                // if(state.ranges[x])
                this.setState(prevState => ({
                    sidebarChanged: true,
                    tmp: {
                        ...prevState.tmp, io: {
                            ...prevState.tmp.io,
                            ai: { ...prevState.tmp.io.ai, curveParams: {
                                ...prevState.tmp.io.ai.curveParams, x: {1: x.min, 2: x.max}, y_fanlevel:{1: y.min, 2: y.max}
                            } },
                        },
                    },
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        ai: true,
                    }
                }))
                break;
            case 2:
                this.setState(prevState => ({
                    sidebarChanged: true,
                    tmp: {
                        ...prevState.tmp, io: {
                            ...prevState.tmp.io,
                            ai: { ...prevState.tmp.io.ai, curveParams: {
                                ...prevState.tmp.io.ai.curveParams, x: {1: x.min, 2: x.max}, y_humi:{1: y.min, 2: y.max}
                            } },
                        },
                    },
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        ai: true,
                    }
                }))
                break;
            case 3:
                this.setState(prevState => ({
                    sidebarChanged: true,
                    tmp: {
                        ...prevState.tmp, io: {
                            ...prevState.tmp.io,
                            ai: { ...prevState.tmp.io.ai, curveParams: {
                                ...prevState.tmp.io.ai.curveParams, x: {1: x.min, 2: x.max}, y_coco:{1: y.min, 2: y.max}
                            } },
                        },
                    },
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        ai: true,
                    }
                }))
                break;
            case 4:
            case 5:
                this.setState(prevState => ({
                    sidebarChanged: true,
                    tmp: {
                        ...prevState.tmp, io: {
                            ...prevState.tmp.io,
                            ai: { ...prevState.tmp.io.ai, curveParams: {
                                ...prevState.tmp.io.ai.curveParams, x: {1: x.min, 2: x.max}, y_temp:{1: y.min, 2: y.max}
                            } },
                        },
                    },
                    ioChanged: {
                        ...prevState.tmp.ioChanged,
                        ai: true,
                    }
                }))
                break;
        }
        log.debug(this.state)

    }

    getSidebarTitle = () => {
        switch (this.state.activeCard) {
            case 'Lüftungssysteme':
                return t('Setup.card_label_systems')

            case 'Bereiche':
                return t('Setup.card_label_boost')

            case 'Eingang DI':
                return t('Setup.card_label_di')

            case 'Eingang AI':
                return t('Setup.card_label_ai')

            case 'Ausgang DO':
                return t('Setup.card_label_do')

            case 'Werkseinstellungen':
                return t('Setup.card_label_factory_reset')

            default:
                return ''

        }
    }

    getCardContentDI = () => {
        switch (this.state.io.di.function) {
            default:
            case "Keine":
                return t('Setup.menuitem_di_none')
            case "Setze Lüfterstufe 0":
                return t('Setup.menuitem_di_set_fanlevel') + '0'
            case "Setze Lüfterstufe 1":
                return t('Setup.menuitem_di_set_fanlevel') + '1'
            case "Setze Lüfterstufe 2":
                return t('Setup.menuitem_di_set_fanlevel') + '2'
            case "Setze Lüfterstufe 3":
                return t('Setup.menuitem_di_set_fanlevel') + '3'
            case "Setze Lüfterstufe 4":
                return t('Setup.menuitem_di_set_fanlevel') + '4'
            case "Setze Lüfterstufe 5":
                return t('Setup.menuitem_di_set_fanlevel') + '5'
            case "Setze Lüfterstufe 6":
                return t('Setup.menuitem_di_set_fanlevel') + '6'
            case "Setze Stoßlüftung":
                return t('Setup.menuitem_di_set_boost')
            case "Setze Schlummer":
                return t('Setup.menuitem_di_set_sleep')
            case "Setze Zeitautomatik":
                return t('Setup.menuitem_di_set_time_automatic')
            case "Setze CO2":
                return t('Setup.menuitem_di_set_co2')
            case "Setze Feuchte":
                return t('Setup.menuitem_di_set_humidity')
            case "Setze Filter zurück":
                return t('Setup.menuitem_di_set_filter')
            case "Halte Lüfterstufe 0":
                return t('Setup.menuitem_di_hold_fanlevel') + '0'
            case "Halte Lüfterstufe 1":
                return t('Setup.menuitem_di_hold_fanlevel') + '1'
            case "Halte Lüfterstufe 2":
                return t('Setup.menuitem_di_hold_fanlevel') + '2'
            case "Halte Lüfterstufe 3":
                return t('Setup.menuitem_di_hold_fanlevel') + '3'
            case "Halte Lüfterstufe 4":
                return t('Setup.menuitem_di_hold_fanlevel') + '4'
            case "Halte Lüfterstufe 5":
                return t('Setup.menuitem_di_hold_fanlevel') + '5'
            case "Halte Lüfterstufe 6":
                return t('Setup.menuitem_di_hold_fanlevel') + '6'
            case "Halte Stoßlüftung":
                return t('Setup.menuitem_di_hold_boost')
            case "Halte Zeitautomatik":
                return t('Setup.menuitem_di_hold_time_automatic')
            case "Halte CO2":
                return t('Setup.menuitem_di_hold_co2')
            case "Halte Feuchte":
                return t('Setup.menuitem_di_hold_humidity')
        }
    }

    getCardContentDO = () => {
        switch (this.state.io.do.function) {
            default:
            case "Keine":
                return t('Setup.menuitem_do_none')
            case "Lüfterstufe 0 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '0' + t('Setup.menuitem_do_fan_active_02')
            case "Lüfterstufe 1 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '1' + t('Setup.menuitem_do_fan_active_02')
            case "Lüfterstufe 2 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '2' + t('Setup.menuitem_do_fan_active_02')
            case "Lüfterstufe 3 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '3' + t('Setup.menuitem_do_fan_active_02')
            case "Lüfterstufe 4 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '4' + t('Setup.menuitem_do_fan_active_02')
            case "Lüfterstufe 5 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '5' + t('Setup.menuitem_do_fan_active_02')
            case "Lüfterstufe 6 aktiv":
                return t('Setup.menuitem_do_fan_active_01') + '6' + t('Setup.menuitem_do_fan_active_02')
            case "Stoßlüftung aktiv":
                return t('Setup.menuitem_do_boost')
            case "Schlummer aktiv":
                return t('Setup.menuitem_do_sleep')
            case "Alle Bereiche Lüfterstufe 0":
                return t('Setup.menuitem_do_all_zero')
            case "Zeitautomatik aktiv":
                return t('Setup.menuitem_do_time_automatic')
            case "CO2 aktiv":
                return t('Setup.menuitem_do_co2')
            case "Feuchte aktiv":
                return t('Setup.menuitem_do_humidity')
            case "Filter abgelaufen":
                return t('Setup.menuitem_do_filter')
            case "Allgemeine Meldung":
                return t('Setup.menuitem_do_message')
            case "Allgemeiner Fehler":
                return t('Setup.menuitem_do_error')

        }
    }

    getCardContentAI = () => {
        switch (this.state.io.ai.function) {
            default:
            case "Keine":
                return t('Setup.menuitem_ai_none')
            case "Lüfterstufe":
                return t('Setup.menuitem_ai_fanlevel')
            case "Feuchte":
                return t('Setup.menuitem_ai_humidity')
            case "CO2":
                return t('Setup.menuitem_ai_co2')
            case "Innentemperatur":
                return t('Setup.menuitem_ai_ti')
            case "Aussentemperatur":
                return t('Setup.menuitem_ai_ta')
        }
    }

    render () {
        const { classes } = this.props
        log.debug(this.props)
        log.debug(this.state)
        return (
            <div style={styles.root}>
                <div style={styles.cardWrapper}>
            <span style={styles.cardsTitle}>
             <Typography variant="h5">{this.props.title}</Typography>
            </span>
                    <Box style={styles.cards} rowGap={theme.dimensions.cardGap/7} columnGap={theme.dimensions.cardGap/7}>
                        <Card
                            label={t('Setup.card_label_systems')}
                            icon={<FanSystemsIcon width={80} height={80}/>}
                            handleCardState={() => this.changeCard('Lüftungssysteme')}
                            active={!(this.state.activeCard === 'Lüftungssysteme' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Setup.card_text_systems_01')]}
                                             content={[`${ Object.keys(this.state.systems).filter(sysKey => this.state.systems[sysKey].type !== 'Keins').length } ` + t('Setup.card_text_systems_02')]}/>
                        </Card>
                        <Card
                            label={t('Setup.card_label_boost')}
                            icon={<AreasIcon width={80} height={80}/>}
                            handleCardState={() => this.changeCard('Bereiche')}
                            active={!(this.state.activeCard === 'Bereiche' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Setup.card_text_boost_01'), t('Setup.card_text_boost_02'), t('Setup.card_text_boost_03')]}/>
                        </Card>
                        <Card
                            label={t('Setup.card_label_di')}
                            icon={<DIIcon width={80} height={80}/>}
                            handleCardState={() => this.changeCard('Eingang DI')}
                            active={!(this.state.activeCard === 'Eingang DI' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Setup.card_text_di_01')]}
                                             content={[this.getCardContentDI()]}/>
                            <CardTextElement label={[t('Setup.card_text_di_02')]}
                                            content = {[ this.showIOcardContent(this.state.io.di.areas)]}
                                            />
                        </Card>
                        <Card
                            label={t('Setup.card_label_ai')}
                            icon={<AIIcon width={80} height={80}/>}
                            handleCardState={() => this.changeCard('Eingang AI')}
                            active={!(this.state.activeCard === 'Eingang AI' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Setup.card_text_ai_01')]}
                                             content={[this.getCardContentAI()]}/>
                            <CardTextElement label={[t('Setup.card_text_ai_02')]}
                                             content={[this.showIOcardContent(this.state.io.ai.areas)]}/>
                        </Card>
                        <Card
                            label={t('Setup.card_label_do')}
                            icon={<DOIcon width={80} height={80}/>}
                            handleCardState={() => this.changeCard('Ausgang DO')}
                            active={!(this.state.activeCard === 'Ausgang DO' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Setup.card_text_do_01')]}
                                             content={[this.getCardContentDO()]}/>
                            <CardTextElement label={[t('Setup.card_text_do_02')]}
                                             content={[this.showIOcardContent(this.state.io.do.areas)]}/>
                        </Card>
                        <Card
                            label={t('Setup.card_label_factory_reset')}
                            icon={<FactorySettingIcon width={80} height={80}/>}
                            handleCardState={() => this.changeCard('Werkseinstellungen')}
                            active={!(this.state.activeCard === 'Werkseinstellungen' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Setup.card_text_factory_reset_01'), t('Setup.card_text_factory_reset_02'), t('Setup.card_text_factory_reset_03')]}/>
                        </Card>
                    </Box>
                </div>

                <Sidebar title={(this.state.aiCurve) ? t('Setup.sidebartitle_curve') : this.getSidebarTitle()}
                         open={this.state.sidebarOpen}
                         changed={(0 === this.state.rangeErrors.length
                                && 0 === this.state.stepErrors.length) ? this.state.sidebarChanged : false}
                         action={(this.state.factoryReset) ? 'factoryReset' : false }
                         closed={() => this.handleSidebarClose()}
                         handleSidebarChange={() => this.handleSidebarChange()}
                         error={!!(this.state.rangeErrors.length) || !!(this.state.stepErrors.length)}
                >
                    {(this.state.factoryReset)
                    && (
                        this.getFactoryResetContent()
                    )
                    }
                    {('Lüftungssysteme' === this.state.activeCard && !this.state.factoryReset && !this.state.aiCurve)
                    && (
                        this.getVentilationSystemsContent()
                    )}
                    {('Bereiche' === this.state.activeCard && !this.state.factoryReset && !this.state.aiCurve)
                    && (
                        this.getAreasContent()
                    )
                    }
                    {('Werkseinstellungen' === this.state.activeCard && !this.state.factoryReset && !this.state.aiCurve)
                    && (
                        <SidebarItem divider>
                            <div style={styles.selectRow}>
                                <Typography variant={'caption'} style={{ marginBottom: 0 }}><Trans i18nKey="Setup.sidebar_text_factory_reset"></Trans></Typography>
                                <CustomizedSwitch
                                    //color="primary"
                                    checked={false}
                                    onChange={() => this.resetToFactorySetting()}
                                />
                            </div>
                        </SidebarItem>
                    )}
                    {(('Ausgang DO' === this.state.activeCard) && !this.state.deletion && !this.state.aiCurve)
                    && (
                       this.getDOSidebarContent()
                    )}
                    {(('Eingang AI' === this.state.activeCard) && !this.state.deletion && !this.state.aiCurve)
                    && (
                       this.getAISidebarContent()
                    )}
                    {(( 'Eingang DI' === this.state.activeCard) && !this.state.deletion && !this.state.aiCurve)
                    && (
                       this.getDISidebarContent()
                    )}
                    {(this.state.aiCurve)
                    && (

                        <div justifyContent='center'>
                            <Graph
                            rangeErrors={this.state.rangeErrors}
                            stepErrors={this.state.stepErrors}
                            ai = {this.state.tmp.io.ai}
                            change={(x,y,context) => this.handleInputCurveChange(x,y,context)}
                            width={260}
                            height={100}
                            />
                      </div>

                    )}
                </Sidebar>
            </div>
        )
    }
}

//Setup = withStyles(styles)(Setup)

export default Setup
